import React, { useState, useEffect, useCallback, useRef } from "react";
import { popupDirections } from "../utils/consts";
import "../css/popup-info-container.css";
import { Icon } from "@iconify/react";
import { motion } from "framer-motion";

const PopupInfoContainer = (props) => {
  const [direction, setDirection] = useState(
    props.direction || popupDirections.right
  );
  const initialDirection = props.direction;
  const [isShow, setIsShow] = useState(false);
  const containerRef = useRef(null);
  const contentRef = useRef(null);

  // Обработчик кликов вне компонента
  const handleClickOutside = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setIsShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  // Проверка позиции popup
  const checkPopupPosition = useCallback(() => {
    if (containerRef.current && contentRef.current) {
      const containerRect = containerRef.current.getBoundingClientRect();
      const contentRect = contentRef.current.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      const windowScroll = window.scrollY;
      const windowHeight = window.scrollY + viewportHeight;

      const currentDirection = direction;
      let newDirection = initialDirection;

      function canBeInitialDirection(currentDirection) {
        if (initialDirection === popupDirections.right) {
          if (containerRect.right + contentRect.width < viewportWidth) {
            newDirection = initialDirection;
          }
        }

        if (
          newDirection === popupDirections.left ||
          newDirection === popupDirections.right
        ) {
          if (
            containerRect.top + windowScroll + contentRect.height >
            windowHeight
          ) {
          }
        }
      }

      if (direction === popupDirections.right) {
        if (containerRect.right + contentRect.width > viewportWidth) {
          if (containerRect.left - contentRect.width >= 0) {
            newDirection = popupDirections.left;
          } else {
            newDirection = popupDirections.bottom;
          }
        }
      } else if (direction === popupDirections.left) {
        if (containerRect.left - contentRect.width < 0) {
          if (containerRect.right + contentRect.width <= viewportWidth) {
            newDirection = popupDirections.right;
          } else {
            newDirection = popupDirections.bottom;
          }
        }
      } else if (direction === popupDirections.bottom) {
        if (containerRect.bottom + contentRect.height > windowHeight) {
          newDirection = popupDirections.top;
        }
      } else if (direction === popupDirections.top) {
        if (containerRect.top - contentRect.height < 0) {
          newDirection = popupDirections.bottom;
        }
      }

      // Проверка выхода за границы страницы (верх и низ)
      // let adjustedTop = contentRect.top;
      // let adjustedBottom = contentRect.bottom;

      // if (adjustedBottom > viewportHeight) {

      //   adjustedTop = viewportHeight - contentRect.height;
      // } else if (adjustedTop < 0) {
      //   adjustedTop = 0;
      // }

      if (newDirection !== direction) {
        setDirection(newDirection);
      }
    }
  }, [direction]);

  // Проверка позиции при изменении состояния
  useEffect(() => {
    if (isShow) {
      checkPopupPosition();
    }
  }, [isShow, checkPopupPosition]);

  return (
    <div ref={containerRef} {...props} className="popup-info-container">
      <div
        onClick={() => setIsShow((prev) => !prev)}
        className="popup-info-button d-flex gap-0-5 justify-between align-items-center"
      >
        <button>{props.value}</button>
        <Icon icon="bxs:up-arrow" className={`arrow ${isShow ? "open" : ""}`} />
      </div>
      {isShow && (
        <motion.div
          ref={contentRef}
          className={`popup-info-content popup-${direction}`}
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.3 }}
        >
          {props.children}
        </motion.div>
      )}
    </div>
  );
};

export default PopupInfoContainer;
